import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label, Input } from "reactstrap";

const CSHDialog = ({
  isOpen,
  title,
  placeholder,
  confirmText,
  cancelText = "Cancel",
  onSubmit,
  onCancel,
  mode = "inputvalue", // default for backward compatibility
  initialValue = "", 
  initialDescription = "",   
}) => {
  const [name, setName] = useState("");
  const [file, setFile] = useState(null);
  const [description, setDescription] = useState("");

  useEffect(() => {
    if (isOpen) {
      setName(initialValue);   
      setFile(null);
      setDescription(initialDescription); 
    }
  }, [isOpen]);

  const handleFileChange = (e) => {
    setFile(e.target.files[0] || null);
    if (e.target.files[0] && !name) {
      setName(e.target.files[0].name);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (mode === "inputvalue") {
      onSubmit(name);
    } else {
      onSubmit({ name, file, description });
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={onCancel}>
      <Form onSubmit={handleSubmit}>
        <ModalHeader toggle={onCancel}>{title}</ModalHeader>
        {mode !== "confirmation" && (
          <ModalBody>
            {mode === "inputvalue" && (
              <FormGroup>
                <Label for="nameInput">{placeholder}</Label>
                <Input
                  id="nameInput"
                  type="text"
                  value={name}
                  placeholder={placeholder}
                  onChange={(e) => setName(e.target.value)}
                  autoFocus
                  required
                />
              </FormGroup>
            )}
            {mode === "upload" && (
              <>
                <FormGroup>
                  <Label for="descriptionInput">Description</Label>
                  <Input
                    id="descriptionInput"
                    type="textarea"
                    value={description}
                    placeholder="Enter description"
                    onChange={(e) => setDescription(e.target.value)}
                    rows={3}
                    //required
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="fileInput">Select file</Label>
                  <Input
                    id="fileInput"
                    type="file"
                    onChange={handleFileChange}
                    required
                  />
                </FormGroup>
              </>
            )}
          </ModalBody>
        )}
        <ModalFooter>
          <Button color="secondary" onClick={onCancel}>
            {cancelText}
          </Button>
          <Button
            color="primary"
            type="submit"
            disabled={
              (mode === "inputvalue" && !name) ||
              (mode === "upload" && (!file))
            }
          >
            {confirmText}
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default CSHDialog;